import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import dayjs from "../../utils/dayjs";

const formatDate = (value: any): string => {
  if (value == null || value === "") return "";
  const d = dayjs.utc(value);
  return d.isValid() ? d.format("MM/DD/YY") : String(value);
};

const dateColumnFormatter = (value: any) => formatDate(value);

export const ContainerMappingContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "po_plan_edit",
        transformId: "container_mapping",
        folder: "outputs",
        title: "Container Mapping",
        noteText:
          "Shows how recommended POs pack into shipping containers; ‘fill’ is pallets used vs. container capacity.",
        dateHierarchyColumnFilter: null,
        // SKU is the only segment we want to offer. The dropdown is built from
        // the RAW po_plan_edit schema (controls/index.tsx reads rawSchema), so
        // every String column on that dataset leaks in unless excluded.
        // purchase_order_id / container_id / container_label / status are all
        // no-op segments the transform never acts on (the view is already at
        // container grain). sku is already a raw column, so it needs no
        // injection; just exclude everything else. Do NOT exclude "sku" itself,
        // or the only real segment disappears. NOTE: po_plan_edit carries BOTH
        // container_id and container_label — exclude both.
        excludedSegmentationsFilter: [
          "purchase_order_id",
          "container_id",
          "container_label",
          "status",
          "location",
          "supplier",
          "sku_name",
        ],
        measureColumnFilter: null,
        // Filter-by dropdown is built from every String/Boolean column on the
        // raw po_plan_edit schema. Restrict it to columns the view actually
        // displays (Container, SKU, SKU name, Location, Supplier) by excluding
        // the rest: purchase_order_id / status / is_floor_loaded never reach the
        // grid, and container_id is the long internal key behind container_label.
        excludedFilterColumnFilter: [
          "purchase_order_id",
          "container_id",
          "status",
          "is_floor_loaded",
        ],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        columnHeaderMap: {
          container_label: "Container",
          sku: "SKU",
          sku_name: "SKU name",
          // Only present at SKU grain (transform emits pallet_qty only then), so
          // the column appears/disappears with the SKU segment automatically.
          pallet_qty: "units/pallet",
          location: "Location",
          supplier: "Supplier",
          quantity: "qty in container",
          // `fill` ("N/21", "1/1") replaces the bare pallet count — it carries
          // both the count and the box capacity. It's a string, so it sorts
          // lexicographically (10/21 before 2/21 at SKU grain) — accepted. If
          // numeric sort-by-share is ever needed, keep the numeric pallet value
          // on the row and render "N/21" via columnFormatters (same pattern as
          // the date columns), NOT a second column.
          fill: "fill",
          order_placed_date: "PO day",
          order_delivery_date: "ETA day",
        },
        columnFormatters: {
          order_placed_date: dateColumnFormatter,
          order_delivery_date: dateColumnFormatter,
        },
        paramsToTransformArgs,
        tableType: "flat",
      }}
      defaultConfig={defaultConfig}
    />
  );
};
